import { HTMLProps } from "react";
import { twMerge } from "tailwind-merge";

export type ButtonProps = Pick<
	HTMLProps<HTMLButtonElement>,
	"disabled" | "className" | "onClick" | "children" | "id"
> & { "data-testid"?: string };

export const Button = (props: ButtonProps) => {
	const classes = twMerge(["border-1 rounded px-2 cursor-pointer", props.className]);
	return (
		<button
			onClick={props.onClick}
			disabled={props.disabled}
			className={classes}
			data-testid={props["data-testid"]}
		>
			{props.children}
		</button>
	);
};
